import React, { memo, useEffect } from "react";
import { useAuth } from "../providers/AuthProvider";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useNavigate } from "react-router-dom";

const AuthRoute = memo(function AuthRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useAuth();
  useEffect(() => {
    if (session.status === "authorized") {
      if (session?.user?.roleCode === "admin") {
        navigate("/admin/dashboard");
        return;
      }
      if (session?.user?.roleCode === "user") {
        navigate("/");
        return;
      }
    }
  }, [session.status, navigate, session?.user?.roleCode]);

  if (session.status === "loading") {
    return <LoadingFallback />;
  }

  return session.status === "unauthorized" ? children : null;
});

export default AuthRoute;
